
import AxiosAPI from "./AxiosAPI";

export const fetchGlobalCatalog = async (type, search = "${search}") => {
  try {
    const response = await AxiosAPI.get(`/globalcatalog/search?type=${type}&searchtext=${search}`);
    return response.data;
  } catch (error) {
    console.log(error, "while fetching the global catalogue")
    throw error.response?.data || error;
  }
};

export const getPincodeGlobalCatalog = async (data) => {
 
  try {
    const response = await AxiosAPI.post(`/globalcatalog`,data);
    return response.data;
  } catch (error) {
    console.log(error, "while fetching the global catalogue")
    throw error.response?.data || error;
  }
}

export async function getPincodeSmartStoreCatalog(code) {
  try {
    const res = await axios.get(
      "https://posibleapi-uat-789032243296.asia-south1.run.app/v1/barcodesvalidat/" +
        code
    );
  
    return res.data;
  } catch (err) {
    // console.log("searchPincodeGlobalCatalog", err);
  }
}

export async function searchPincodeGlobalCatalog(
  code,
  name,
  type = "",
  searchtext = ""
) {
  try {
    const res = await axios.post(
      "https://us-central1-posible-app-prod.cloudfunctions.net/apiSearchPincodeGlobalCatalog",
      { code: code, name: name, type: type, searchtext: searchtext }
    );
    // console.log(JSON.stringify(res.data));
    return res.data.pincodeCatalog;
  } catch (err) {
    // console.log("searchPincodeGlobalCatalog", err);
  }
}

export async function checkProductType() {
  try {
    const res = await AxiosAPI.get(
      "/checkproductype" 
    );
   
    return res.data;
  } catch (err) {
    // console.log("searchPincodeGlobalCatalog", err);
  }
}
